import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh; // Viewport'un tamamını kaplasın
  text-align: center;
`;

export const Logo = styled.img`
  width: 200px;
`;

export const WarningMessage = styled.p`
  margin: 0.5rem 0 2rem;
  color: #333;
  font-size: 1.5rem;
`;

export const DownloadButtonContainer = styled.div`
  display: flex;
  justify-content: center; // This will center the images horizontally
  align-items: center; // This will center the images vertically
  a {
    margin: 0.5rem;
  }
  img {
    width: 150px;
    height: auto;
  }
`;
